import { IoSettingsSharp } from "react-icons/io5";
import useSecurity from "./useSecurity";
import { FaBarcode, FaChartBar, FaListUl, FaMoneyBillAlt } from "react-icons/fa";
import { MdDeveloperMode, MdSupervisorAccount } from "react-icons/md";

const useMasterDashboardNavbar = () => {
  const { hasPrivilege, isUserRoleEquals } = useSecurity();

  const navbarData = [
    {
      path: "/accounts",
      name: "Accounts",
      icon: <MdSupervisorAccount className="stats-navbar-item-icon" size={20} />,
      privilege: "Accounts",
    },
    {
      path: "/subscribers",
      name: "Subscribers",
      icon: <MdSupervisorAccount className="stats-navbar-item-icon" size={20} />,
      privilege: "Subscribers",
    },
    {
      path: "/partners",
      name: "Partners",
      icon: <MdSupervisorAccount className="stats-navbar-item-icon" size={20} />,
      privilege: "Partners",
    },
    {
      path: "/ratePlans",
      name: "Rate Plans",
      icon: <FaListUl className="stats-navbar-item-icon" size={14} />,
      privilege: "RatePlans",
    },
    {
      path: "/usagePricing",
      name: "Usage Pricing",
      icon: <FaMoneyBillAlt className="stats-navbar-item-icon" size={20} />,
      privilege: "UsagePricing",
    },
    {
      path: "/reports",
      name: "Reports",
      icon: <FaChartBar className="stats-navbar-item-icon" size={18} />,
      privilege: "Reports",
    },
    {
      path: "/resources",
      name: "Resources",
      icon: <FaBarcode className="stats-navbar-item-icon" size={16} />,
      privilege: "Manage Resources",
    },
    {
      path: "/administration",
      name: "Administration",
      icon: <IoSettingsSharp className="stats-navbar-item-icon" size={16} />,
      privilege: "Administration",
    },
    {
      path: "/roles",
      name: "Roles",
      icon: <FaListUl className="stats-navbar-item-icon" size={14} />,
      privilege: "ManageRoles",
    },
    {
      path: "/dev",
      name: "Dev",
      icon: <MdDeveloperMode className="stats-navbar-item-icon" size={14} />,
      role: "SUPER_ADMIN",
    },
  ];

  const showTab = (tab) => {
    if (tab.privilege) return hasPrivilege(tab.privilege);
    if (tab.role) return isUserRoleEquals(tab.role);
    return true;
  };

  const getNavbarData = () => {
    return navbarData;
  };

  const getFirstAccessibleRoute = (userPrivileges, userRole) => {
    const firstAccessibleRoute = navbarData.find((route) => {
      if (route.role && userRole !== route.role) return false;
      if (route.privilege && !userPrivileges.includes(route.privilege)) return false;
      return true;
    });

    return firstAccessibleRoute ? firstAccessibleRoute.path : null;
  };

  return { getNavbarData, getFirstAccessibleRoute, showTab };
};

export default useMasterDashboardNavbar;
